import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/question-template-management/components/TemplateManagementClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppLayout.tsx");
